<script setup lang="ts">
const logos = [
  "/svg/new/customers/irancell.svg",
  "/svg/new/customers/ict.svg",
  "/svg/new/customers/tw.svg",
  "/svg/new/customers/ata-airlines.svg",
  "/svg/new/customers/shaskam.svg",
  "/svg/new/customers/pishkhan.svg",
  "/svg/new/customers/goldiran.svg",
  "/svg/new/customers/azar.svg",
  "/svg/new/customers/drik.svg",
  "/svg/new/customers/gsa-ata.svg",
  "/svg/new/customers/kitline.svg",
  "/svg/new/customers/tractor.svg",
  "/svg/new/customers/alo-jarah.svg",
  "/svg/new/customers/hw-city.svg",
  "/svg/new/customers/ketabchi.svg",
  "/svg/new/customers/motori-24.svg",
  "/svg/new/customers/azimzadeh.svg",
  "/svg/new/customers/ramak.svg",
];
</script>

<template>
    <SectionsBase class="container">
        <div class="w-full flex items-center justify-center gap-2 lg:gap-8">
            <IconsLine class="bg-linear-to-r from-warning-700 to-warning-200" />
            <p class="h4 text-gray-500 text-center">
                نواتل؛ مورد اعتماد شرکت‌ها و برندهای برتر ایرانی
            </p>
            <IconsLine class="bg-linear-to-r from-warning-700 to-warning-200 rotate-180" />
        </div>
        <SlidersAutoScroll
            height="h-12"
            gap="gap-8"
            pr="pr-8"
            duration="50s"
            class="mt-5 mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]
                [-webkit-mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]"
        >
            <NuxtImg 
                v-for="logo in logos"
                :key="logo"
                :src="logo"
                :alt="logo.split('/').pop()!.split('.')[0]"
                height="48"
                class="h-9 lg:h-12"
                loading="lazy"
            />
        </SlidersAutoScroll>
    </SectionsBase>
</template>
